export default __webpack_public_path__ + "static/media/logo1.1a82ba6c.jpg";